<template>
  <div class="culturalCollection">
    <div class="navbar">
      <span>藏品详情</span>
      <img src="@/assets/images/detail/back.png" alt="" class="back" @click="back" />
    </div>
    <div class="collect_content">
      <div class="object_img">
        <!-- <img src="@/assets/images/detail/culturalCollection/outline.png" alt="" class="outline" /> -->
        <img src="@/assets/images/detail/culturalCollection/bg.png" alt="" class="bg" />
        <img :src="detailInfo.picUrl" alt="" class="object" />
        <div class="bg_img">
          <img :src="detailInfo.picUrl" alt="" class="bg_picUrl" />
        </div>
        <!-- <img src="../../assets/images/detail/culturalCollection/bg_img.png" alt="" class="bg_img" /> -->
        <div class="msg d-f fxd-c ai-c">
          <div class="msg_title">{{ detailInfo.name }}</div>
          <div class="dynasty">{{ detailInfo.dynasty }}</div>
          <div class="size" v-if="detailInfo.size">尺寸：{{ detailInfo.size }}</div>
          <div class="publish_company d-f ai-c">
            <img src="@/assets/images/detail/culturalCollection/company.png" alt="" class="icon" />
            <span>发布单位：{{ detailInfo.publishUnitName }}</span>
          </div>
          <div class="collect_company d-f ai-c">
            <img src="@/assets/images/detail/culturalCollection/company.png" alt="" class="icon" />
            <span>收藏单位：{{ detailInfo.collectionUnitName }}</span>
          </div>
        </div>
      </div>
      <div class="synopsis" v-if="detail">
        <div class="title">
          <span>简介</span>
          <!-- <img src="@/assets/images/detail/culturalCollection/title-bg.png" alt="" /> -->
        </div>
        <div class="content" v-html="detail">
          <!-- {{ detailInfo.detail }} -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { format } from '@/utils/DES.js'
import { collectionDetails } from '@/api/collection'
export default {
  data() {
    return {
      detailInfo: {},
      detail: '',
    }
  },
  methods: {
    back() {
      this.$myUni.navigateBack({
        delta: 1,
      })
    },
    getDetail(id) {
      collectionDetails(id).then((res) => {
        console.log(res)
        this.detailInfo = res.result
        this.detail = format(this.detailInfo.detail)
      })
    },
  },
  mounted() {
    const data = JSON.parse(this.$route.query.params)
    this.getDetail(data.id)
  },
}
</script>
<style lang="scss" scoped>
.culturalCollection {
  width: 100%;
  height: 100vh;
  background: #fff;

  .navbar {
    z-index: 9999;
    width: 100%;
    height: 44px;
    position: fixed;
    top: 40px;
    // top: calc(40px + env(safe-area-inset-top));
    left: 0;
    text-align: center;
    line-height: 44px;
    font-weight: 600;
    color: #112a26;
    font-size: 0.9rem;
    background: #fff;
    .back {
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 0.5rem;
    }
  }
  .collect_content {
    padding: 0.2rem 0.6rem 0 0.6rem;
    padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
    width: 100%;
    // height: calc(100% - 44px - 40px - env(safe-area-inset-top));
    height: calc(100% - 84px);
    position: absolute;
    // top: calc(44px + 40px + env(safe-area-inset-top));
    top: 84px;
    left: 0;
    overflow-y: auto;
  }

  .object_img {
    position: relative;
    height: 17.45rem;
    .outline {
      width: 100%;
      height: 17.45rem;
    }
    .bg {
      position: absolute;
      top: 2px;
      left: 2px;
      width: calc(100% - 4px);
      height: calc(100% - 4px);
    }
    .object {
      position: absolute;
      top: 1rem;
      left: calc(50% - 2.1rem);
      // width: 8.4rem;
      // height: auto;
      height: 6.3rem;
      // object-fit: cover;
      max-width: 100%;
      // height: 6.3rem;
    }
    .bg_img {
      position: absolute;
      width: calc(100% - 4px);
      height: 50%;
      bottom: 2px;
      left: 2px;
      background-color: rgba(169, 112, 72);
      border-radius: 0 0 0.6rem 0.6rem;
      // position: relative;
      overflow: hidden;
      .bg_picUrl {
        position: absolute;
        margin-left: 40%;
        opacity: 0.2;
        // left: 45%;
        top: -25%;
        // height: 16.5rem;
      }
    }
    .msg {
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 1.2rem;
      font-size: 0.6rem;
      color: #ffffff;
      line-height: 0.8rem;
      .msg_title {
        text-align: center;
        font-size: 0.7rem;
        font-weight: 600;
        line-height: 1rem;
      }
      .dynasty {
        margin: 0.4rem 0;
        height: 0.9rem;
        line-height: 0.9rem;
        background: rgba(255, 255, 255, 0.15);
        border-radius: 2px;
        padding: 0 0.4rem;
      }
      .publish_company {
        margin: 0.4rem 0;
      }
      .publish_company,
      .collect_company {
        .icon {
          width: 0.7rem;
          height: 0.7rem;
          margin-right: 0.2rem;
        }
      }
    }
  }
  .synopsis {
    margin-top: 1.2rem;
    .title {
      position: relative;
      font-size: 0.8rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.2rem;
      text-align: center;
      margin-bottom: 0.6rem;
      img {
        position: absolute;
        top: 0.5rem;
        right: calc(50% - 1.4rem);
        width: 2.8rem;
        height: 0.9rem;
      }
    }
    .content {
      font-size: 0.7rem;
      color: #666666;
      line-height: 1rem;
      // img {
      //   width: 100%;
      //   height: 9.7rem;
      //   margin: 0.8rem 0;
      //   border-radius: 0.5rem;
      // }
    }
  }
}
</style>
